import { switchMap, withLatestFrom } from "rxjs/operators";
import { HandlerBase } from "../../utils/HandlerBase";
import { EdgeDirection } from "../../graph/edge/EdgeDirection";
import { AbortInfra3DSDKError } from "../../error/AbortInfra3DSDKError";
/**
 * The `KeySequenceNavigationHandler` allows the user to navigate through a sequence using the
 * following key commands:
 *
 * `ALT` + `Left Arrow`: Navigate to next image in the sequence.
 * `ALT` + `Right Arrow`: Navigate to previous image in sequence.
 *
 * @example
 * ```
 * var keyboardComponent = viewer.getComponent("keyboard");
 *
 * keyboardComponent.keySequenceNavigation.disable();
 * keyboardComponent.keySequenceNavigation.enable();
 *
 * var isEnabled = keyboardComponent.keySequenceNavigation.isEnabled;
 * ```
 */
export class KeySequenceNavigationHandler extends HandlerBase {
    _enable() {
        const sequenceEdges$ = this._navigator.stateService.currentNode$.pipe(switchMap((node) => {
            return node.sequenceEdges$;
        }));
        this._keyDownSubscription = this._container.keyboardService.keyDown$
            .pipe(withLatestFrom(sequenceEdges$, this._navigator.playService.bridge$))
            .subscribe(([event, edgeStatus, bridge]) => {
            let direction = null;
            switch (event.keyCode) {
                case 39: // up
                    direction = EdgeDirection.Next;
                    break;
                case 37: // down
                    direction = EdgeDirection.Prev;
                    break;
                default:
                    return;
            }
            event.preventDefault();
            if (!event.altKey || event.shiftKey || !edgeStatus.cached) {
                return;
            }
            let key = null;
            for (const edge of edgeStatus.edges) {
                if (edge.data.direction === direction) {
                    key = edge.to;
                    break;
                }
            }
            if (!key && bridge) {
                if (bridge.assetsCached)
                    key = bridge.key;
            }
            if (key) {
                this._navigator.moveToKey$(key).subscribe(undefined, (error) => {
                    if (!(error instanceof AbortInfra3DSDKError)) {
                        console.error(error);
                    }
                });
            }
        });
    }
    _disable() {
        this._keyDownSubscription.unsubscribe();
    }
    _getConfiguration(enable) {
        return { keySequenceNavigation: enable };
    }
}
//# sourceMappingURL=KeySequenceNavigationHandler.js.map